/*
 * @Author: your name
 * @Date: 2022-01-11 20:57:46
 * @LastEditTime: 2022-08-04 14:17:52
 * @LastEditors: LHB
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /shirleyClass/src/utils/urls.js
 */
/** 测试接口 */
const testHost = 'https://test.api.xueliyingyu.com'
/** 生产接口 */
const proHost = 'https://api.xueliyingyu.com'

let host = proHost

let locationUrl = ''
let bindUrl = ''
let urlHost = ''
if (host == proHost) {
  locationUrl =
    'https://static.xueliyingyu.com/fe/prod/shirleyClass/index.html#/'
  bindUrl =
    'https://static.xueliyingyu.com/fe/prod/shirleyClass/index.html#/bindwx'
} else {
  locationUrl =
    'https://static.xueliyingyu.com/fe/test/shirleyClass/index.html#/'
  bindUrl =
    'https://static.xueliyingyu.com/fe/test/shirleyClass/index.html#/bindwx'
  var vConsole = new VConsole()
}

export default {
  locationUrl,
  bindUrl,
  urlHost,
  /********************** 本次新接口-start*************************** */

  // 微信登录
  wxLogin: `${host}/api/h5/user/wxLogin`,
  // 手机号验证码登陆、手机号密码登录
  mobileLogin: `${host}/api/h5/user/mobileLogin`,
  // 开课校验
  openVerify: `${host}/api/h5/course/openVerify`,
  // 开课操作
  open: `${host}/api/h5/course/open`,
  // 兑换课程
  redeem: `${host}/api/h5/course/redeem`,
  // 课程列表
  courseList: `${host}/api/h5/course/list`,
  // 课程学习上报
  reportLearn: `${host}/api/h5/course/reportLearn`,
  // 雪梨信箱
  feedback: `${host}/api/h5/feedback`,
  // 广告位列表
  bannerList: `${host}/api/h5/ad/banner/list`,
  // 设置用户密码
  resetPwd: `${host}/api/h5/user/resetPwd`,
  // 用户资料编辑
  infoModify: `${host}/api/h5/user/infoModify`,
  // 获取用户资料
  userGet: `${host}/api/h5/user/get`,
  // 更换手机号
  mobileModify: `${host}/api/h5/user/mobileModify`,
  // 用户换绑微信申请创建
  createBind: `${host}/api/h5/user/wxChangeApply/create`,
  // 用户换绑微信申请查询
  checkBind: `${host}/api/h5/user/wxChangeApply/get`,
  // 用户换绑微信申请执行（绑定操作）
  execute: `${host}/api/h5/user/wxChangeApply/execute`,

  // 我的订单列表(聚合)
  orderList: `${host}/api/h5/order/listAll`,

  /********************** 本次新接口-end***************************** */

  // 获取微信jssdk签名
  jsapiSign: `${host}/api/h5/wx/jsapi`,
  // 用code获取用户信息
  wxpaLogin: `${host}/api/h5/wx/user/login`,
  // 被邀请人用code获取用户信息
  wxLoginJoin: `${host}/api/h5/item/wxLoginJoin`,
  // 获取商品信息
  detail: `${host}/api/h5/item/detail`,
  // 下单
  create: `${host}/api/h5/order/create`,
  // 取消订单
  cancel: `${host}/api/h5/order/cancel`,
  // 主页活动信息
  promoDetail: `${host}/api/h5/promo/detail`,
  // 我去我邀请的人的记录
  getHistory: `${host}/api/h5/promo/join/list`,
  // 查询邀请记录
  inviteGet: `${host}/api/h5/promo/invite/get`,
  // 发起邀请有礼
  inviteSave: `${host}/api/h5/promo/invite/save`,
  // 发起邀请有礼
  recvGift: `${host}/api/h5/promo/invite/recvGift`,
  // 我获得的礼包
  giftList: `${host}/api/h5/promo/gift/list`,
  // 我获得的礼包-详情
  giftDetail: `${host}/api/h5/promo/gift/detail`,
  // 我获得的礼包-详情
  buyVerify: `${host}/api/h5/item/buyVerify`,
  // 物流明细
  delivery: `${host}/api/h5/order/delivery`,

  // 查询任务进度
  inviteTask: `${host}/api/h5/promo/invite/task`,
  joinIn: `${host}/api/h5/promo/join/in`,
  // 发送验证码
  sendCode: `${host}/api/h5/wx/sendCode`,

  createZero: `${host}/api/h5/order/create/zero`
}
